import React, { useEffect, useId, useRef, useState } from 'react';
import { MoreHorizontal, Pencil, RotateCcw } from 'lucide-react';
import { t } from '../i18n';

export default function CardActionsMenu({ onEdit, onReview, disabled = false, className = '', onOpenChange }) {
  const [open, setOpen] = useState(false);
  const root = useRef(null);
  const trigger = useRef(null);
  const menu = useRef(null);
  const id = useId();
  useEffect(() => { onOpenChange?.(open); }, [open, onOpenChange]);
  useEffect(() => { if (disabled) setOpen(false); }, [disabled]);
  useEffect(() => {
    if (!open) return undefined;
    menu.current?.querySelector('button')?.focus();
    const outside = event => { if (!root.current?.contains(event.target)) setOpen(false); };
    document.addEventListener('pointerdown', outside, true);
    return () => document.removeEventListener('pointerdown', outside, true);
  }, [open]);
  const close = () => { setOpen(false); trigger.current?.focus(); };
  const choose = action => { close(); action?.(); };
  return <div className={`flashcard-map-actions ${className}`} ref={root} onClick={event => event.stopPropagation()}
    onBlur={event => { if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget) && !event.relatedTarget.contains?.(event.currentTarget)) setOpen(false); }}
    onKeyDown={event => {
      event.stopPropagation();
      if (disabled) return;
      if (event.key === 'Escape') { event.stopPropagation(); event.preventDefault(); close(); }
      if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
      event.preventDefault();
      if (!open) { setOpen(true); return; }
      const items = Array.from(menu.current.querySelectorAll('button'));
      const index = items.indexOf(document.activeElement);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? items.length - 1 : (index + (event.key === 'ArrowUp' ? -1 : 1) + items.length) % items.length;
      items[next]?.focus();
    }}>
    <button type="button" className="flashcard-map-edit-btn" disabled={disabled} ref={trigger} aria-label={t('learningNavigation.map.actions')}
      title={t('learningNavigation.map.actions')} aria-haspopup="menu" aria-expanded={open} aria-controls={open ? id : undefined}
      onClick={() => setOpen(value => !value)}><MoreHorizontal size={20} aria-hidden="true" /></button>
    {open && <div className="flashcard-map-actions-menu" role="menu" id={id} ref={menu} aria-label={t('learningNavigation.map.actions')}>
      {onEdit && <button type="button" role="menuitem" onClick={() => choose(onEdit)}><Pencil size={16} aria-hidden="true" />{t('learningNavigation.map.edit')}</button>}
      {onReview && <button type="button" role="menuitem" onClick={() => choose(onReview)}><RotateCcw size={16} aria-hidden="true" />{t('learningNavigation.map.learnAgain')}</button>}
    </div>}
  </div>;
}
